import { Link } from 'react-router-dom'
import Seo from '../components/Seo.jsx'
import Container from '../components/Container.jsx'

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" noIndex />
      <main className="pt-20">
        <Container className="flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
          <div className="text-7xl font-extrabold text-gradient">404</div>
          <h1 className="mt-4 text-2xl">This page wandered off</h1>
          <p className="mt-3 max-w-md text-slate-400">
            The page you’re looking for doesn’t exist or may have moved.
          </p>
          <Link to="/" className="btn-primary mt-8">Back to home</Link>
        </Container>
      </main>
    </>
  )
}
